// Componentes
import PhoneFrame from "./PhoneFrame";

// Icones
import {
  FaArrowRotateRight,
  FaClock,
  FaLocationDot,
  FaQrcode,
  FaRegImage,
  FaRightFromBracket,
} from "react-icons/fa6";

// Estilos
import "./eventsListPreview.css";

/**
 * Card de evento ficticio, só para mostrar como as cores ficam nele. Espelha o
 * renderFrontCard de app/components/CardEvent.js: corpo em
 * theme.ui.events_cards.background e footer em
 * theme.ui.events_cards.footer_bg, com o texto de data na cor primária.
 */
function EventCard({ bodyColor, footerColor, dateColor }) {
  return (
    <div className="events-preview__card">
      <div className="events-preview__card-image">
        <FaRegImage size={16} />
        <span>Imagem do evento</span>
      </div>

      <div
        className="events-preview__card-body"
        style={{ backgroundColor: bodyColor }}
      >
        <span className="events-preview__card-title">Evento de Demonstração</span>

        <span className="events-preview__card-row">
          <FaQrcode size={10} />
          Credencial de Acesso
        </span>

        <span className="events-preview__card-row">
          <FaLocationDot size={10} />
          Centro de Convenções — São Paulo
        </span>
      </div>

      <div
        className="events-preview__card-footer"
        style={{ backgroundColor: footerColor }}
      >
        <span className="events-preview__card-date" style={{ color: dateColor }}>
          <FaClock size={10} />
          12 de agosto de 2026 das 09:00 às 18:00
        </span>
      </div>
    </div>
  );
}

/**
 * Previa estatica da lista de eventos do app app-expo-inteegra-eventos. Espelha
 * app/pages/EventsPage/index.js: fundo branco, header com a logo da lista de
 * eventos e as acoes Atualizar/Sair, saudacao e a lista de cards.
 */
export default function EventsListPreview({
  primaryColor,
  secondaryColor,
  logoUrl,
  backgroundColor,
  textColor,
  dateColor,
}) {
  const bodyColor = primaryColor || "#092a49";
  const footerColor = secondaryColor || "#204f7d";

  // sem cor escolhida cada texto fica no default que o app usa hoje, que vem do
  // css: preto nas ações e #242e40 na saudação e no subtítulo
  const textStyle = textColor ? { color: textColor } : undefined;

  return (
    <PhoneFrame backgroundColor={backgroundColor || "#fff"}>
      <div className="events-preview__header">
        <div className="events-preview__logo-wrapper">
          {logoUrl && (
            <img
              className="events-preview__logo"
              src={logoUrl}
              alt="Logo da lista de eventos"
            />
          )}
        </div>

        <div className="events-preview__actions">
          <span className="events-preview__action" style={textStyle}>
            <FaArrowRotateRight size={12} />
            Atualizar
          </span>
          <span className="events-preview__action" style={textStyle}>
            <FaRightFromBracket size={12} />
            Sair
          </span>
        </div>
      </div>

      <span className="events-preview__greeting" style={textStyle}>
        Olá, Participante
      </span>
      <span className="events-preview__subtitle" style={textStyle}>
        Confira seus eventos
      </span>

      {/* o segundo card fica cortado na borda da tela, como numa lista rolável */}
      <div className="events-preview__list">
        <EventCard
          bodyColor={bodyColor}
          footerColor={footerColor}
          dateColor={dateColor || bodyColor}
        />
        <EventCard
          bodyColor={bodyColor}
          footerColor={footerColor}
          dateColor={dateColor || bodyColor}
        />
      </div>
    </PhoneFrame>
  );
}
